<template>
  <div class="frame" v-bind:class="{ large: bordersize === 'large' }">
    <div class="side top"></div>
    <div class="side left"></div>
      <slot></slot>
    <div class="side right"></div>
    <div class="side bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'Framer',
  props: ['bordersize']
}
</script>

<style>

.frame {
  width: 100%;
  min-height: 100%;
  top: 0px;
  background-color: #9E9E9E;
  padding-top: 17px;
  box-sizing: border-box;
  left: 0px;
  position: absolute;
  z-index: 9999999;
}
.frame.large {
  padding: 60px;
}
.side {
  position: absolute;
}
.top {
  /* background-color: #CCCCCC; */
  width: 100%;
  height: 0px;
  border: 10px solid transparent;
  border-top: 10px solid #CCCCCC;
  border-bottom: 0px;
  top: 0px;
  left: 0px;
  box-sizing: border-box;
  z-index: 99;
}
.large .top {
  border: 40px solid transparent;
  border-top: 40px solid #CCCCCC;
  border-bottom: 0px;
}
.left {
  background-color: #AFAFAF;
  width: 10px;
  height: 100%;
  top: 0px;
  left: 0px;
}
.large .left {
  width: 40px;
}
.right {
  background-color: #6D6D6D;
  width: 10px;
  height: 100%;
  top: 0px;
  right: 0px;
}
.large .right {
  width: 40px;
}
.bottom {
  height: 10%;
  width: 100%;
  bottom: 0px;
  left: 0px;
  border: 10px solid transparent;
  border-bottom: 10px solid #515151;
  border-top: 0px;  
  box-sizing: border-box;
  z-index: 99;
}
.large .bottom {
  border: 40px solid transparent;
  border-bottom: 40px solid #515151;
  border-top: 0px; 
}
</style>



// WEBPACK FOOTER //
// src/components/Framer.vue